<template>
	<div class="page flex-column">
		<div class="head flex-center">
			<div class="welcome flex-center">欢迎登录系统！今天是星期{{week[new Date().getDay()]}}</div>
			<div class="date flex-center">数据更新：{{date}}</div>
		</div>
		<div class="body flex-between flex-grow">
			<div class="body-col flex-column">
				<module title="佣金奖励总榜">
					<commision ref="commision"></commision>
				</module>
				<module title="销售TOP地区" style="flex-grow: 1.8;">
					<region ref="region"></region>
				</module>
			</div>
			<div class="body-main flex-grow">
				<div class="total flex">
					<div class="flex-column flex-grow flex-center">
						<strong>{{totalData.user_count}}</strong>
						<p>用户总数</p>
					</div>
					<div class="flex-column flex-grow flex-center">
						<strong>{{totalData.award_money}}</strong>
						<p>累计发放奖励</p>
					</div>
					<div class="flex-column flex-grow flex-center">
						<strong>{{totalData.member_count}}</strong>
						<p>代理商数</p>
					</div>
				</div>
				<div class="map">
					<img src="@/assets/image/digital/map.png" alt="">
					
					<div v-for="(item, i) in regionList" :key="i" class="item" :style="{'z-index': targetRegion == item.index ? 1 : 0, 'left': `${item.coor[0]}%`, 'top': `${item.coor[1]}%`}" @mouseenter="targetRegion = item.index">
						<div class="light" :style="{'animation-delay': `${-item.index * 0.15}s`}"></div>
						<div class="point"></div>
						<div class="content" :class="{'z-active': targetRegion == item.index}">
							<img class="icon" src="@/assets/image/digital/map_icon.png" alt="">
							<div class="data flex-column flex-center-main">
								<p>{{item.province_name}}</p>
								<p>GMV：￥{{item.money}}</p>
								<p>用户数：{{item.user_count}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="body-col flex-column">
				<module title="近30天分享奖励排行榜">
					<share ref="share"></share>
				</module>
				<module title="代理商类型分布">
					<agent ref="agent"></agent>
				</module>
				<module title="会员类型统计">
					<vip ref="vip"></vip>
				</module>
			</div>
		</div>
		
		<img class="foot" src="@/assets/image/digital/foot_line.png">
	</div>
</template>

<script>
	import module from './components/digital_module.vue'
	import commision from './components/commision.vue'
	import region from './components/region.vue'
	import share from './components/share.vue'
	import agent from './components/agent.vue'
	import vip from './components/vip.vue'
	import {createStore, mapStore} from './components/store.js'
	
	function throttle(fun, timer = 100, options) {
		options = Object.assign({
			immediate: true,
			trailing: true
		}, typeof options == 'boolean' ? {
			trailing: options
		} : options);

		let timeout, context, args;
		let previous = 0;

		const later = () => {
			previous = options.immediate === false ? 0 : Date.now();
			timeout = null;
			fun.apply(context, args);
			if (!timeout) context = args = null;
		};

		return function(...params) {
			const now = Date.now();
			if (!previous && options.immediate === false) previous = now;

			const remaining = timer - (now - previous);
			context = this;
			args = params;
			if (remaining <= 0 || remaining > timer) {
				if (timeout) {
					clearTimeout(timeout);
					timeout = null;
				}
				previous = now;
				fun.apply(context, args);
				if (!timeout) context = args = null;
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining);
			}
		};
	}

	export default {
		components: {
			module,
			commision,
			region,
			share,
			agent,
			vip
		},

		data() {
			return {
				digitalStore: createStore({
					px(n) {
						return n * 0.00052083 * window.innerWidth;
					},
					registerChart: obj => {
						this.charts.push(obj);
					},
					processRateScale: 1
				}),
				week: {
					0: '日',
					1: '一',
					2: '二',
					3: '三',
					4: '四',
					5: '五',
					6: '六'
				},
				date: '',
				charts: [],
				
				totalData: {
					user_count: 0,
					award_money: 0,
					member_count: 0
				},
				regionCoor: {
					'北京市': [59.2, 38],
					'浙江省': [64, 61],
					'天津市': [60, 40],
					'广东省': [56.5, 75],
					'上海市': [65.2, 57.6],
					'宁夏回族自治区': [49, 42],
					'福建省': [62, 69],
					'吉林省': [67.5, 33],
					'贵州省': [49, 66],
					'四川省': [45, 56],
					'青海省': [38, 44],
					'西藏自治区': [33, 54.5],
					'陕西省': [51, 50],
					'河南省': [57, 50],
					'香港特别行政区': [57, 80],
					'云南省': [41, 70],
					'内蒙古自治区': [53, 35],
					'安徽省': [60.5, 54],
					'重庆市': [50, 58],
					'江西省': [59, 64],
					'湖北省': [54.5, 56],
					'辽宁省': [65, 36],
					'新疆维吾尔自治区': [34, 34],
					'山西省': [55, 42],
					'江苏省': [63, 52],
					'海南省': [51, 87],
					'台湾省': [65.5, 76],
					'河北省': [58, 41],
					'广西壮族自治区': [50, 74],
					'黑龙江省': [68, 26],
					'甘肃省': [47, 45],
					'湖南省': [54, 63],
					'澳门特别行政区': [55, 80.8],
					'山东省': [61, 45]
				},
				regionList: [],
				targetRegion: -1
			}
		},

		computed: {
			...mapStore('digitalStore', ['px'])
		},
		
		watch: {
			targetRegion(val) {
				clearTimeout(this._mapTimer);
				this._mapTimer = setTimeout(() => {
					this.targetRegion = this.regionList.find(item => item.index == (val == this.regionList.length - 1 ? 0 : (val + 1))).index;
				}, 5000);
			}
		},

		mounted() {
			this.update();
			this.updateMap();
			this.digitalStore.commit('processRateScale', this.px(40) / 70);
			window.addEventListener('resize', throttle(() => {
				this.charts.forEach(item => {
					item.resize();
				});
				this.digitalStore.commit('processRateScale', this.px(40) / 70);
			}, 500));
		},
		
		methods: {
			update() {
				this.request({
					url: '/visual/data/statistic',
					success: data => {
						['user_count', 'award_money', 'member_count'].forEach(item => {
							let start = this.totalData[item];
							let max = parseFloat(data[item]);
							let dir = start < max ? 1 : -1;
							max = Math.abs(parseFloat(max - start));
							let num = 0, gradient = max / 40;
							
							!function loop() {
								if (num < max) {
									num += gradient;
									if (num > max) {
										num = max;
									}
									this.totalData[item] = parseFloat(parseFloat(start + dir*num).toFixed(item == 'award_money' ? 2 : 0));
									setTimeout(loop.bind(this), 20);
								}
							}.call(this);
						});
					}
				});
				
				['commision', 'region', 'share', 'agent', 'vip'].forEach(item => {
					this.$refs[item].update();
				});
				
				setTimeout(this.update, 60000);
				this.date = new Date().format('yyyy年MM月dd日 hh:mm');
			},
			
			updateMap() {
				this.request({
					url: '/visual/data/region/list',
					success: data => {
						data = data.map(item => {
							item.coor = this.regionCoor[item.province_name];
							return item;
						}).filter(item => item.coor);
						let index = new Array(data.length).fill('').map((item, index) => index);
						this.regionList = data.map(item => {
							let i = getRandomInt(0, index.length - 1);
							item.index = index[i];
							index.splice(i, 1);
							return item;
						});
						this.targetRegion = 0;
						
						function getRandomInt(min, max) {
							min = Math.ceil(min);
							max = Math.floor(max);
							return Math.floor(Math.random() * (max - min + 1)) + min;
						}
					}
				});
				setTimeout(this.updateMap, 300000);
			}
		}
	}
</script>

<style lang="stylus">
	html {
		font-size: 5.2083vw;
	}
</style>

<style lang="stylus" scoped>
	@font-face {
	    font-family: 'digital';
	    src: url('~@/assets/image/digital/DingTalk-JinBuTi.ttf') format('truetype');
	}
	
	.page {
		box-sizing: border-box;
		height: 100vh;
		overflow: hidden;
		font-family: 'digital';
		background-color: #000;
		background-image: url('~@/assets/image/digital/bg.jpg');
		background-size: 100% 100%;
		background-position: center;
		background-repeat: no-repeat;
		user-select: none;

		.head {
			z-index: 1;
			position: relative;
			height: .72rem;
			margin-bottom: .22rem;
			background-image: url('~@/assets/image/digital/head.png');
			background-size: auto 100%;
			background-position: center;
			
			&:after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				width: .5rem;
				height: .02rem;
				background-image: url('~@/assets/image/digital/an_head.png');
				background-size: 100%;
				animation: headMove 5s infinite linear;
			
				@keyframes headMove {
					0% {
						opacity: 0;
						transform: translate(0,0);
					}
					10% {
						opacity: 1;
					}
					70% {
						opacity: 1;
					}
					80% {
						opacity: 0;
						transform: translate(100vw,0);
					}
					100% {
						opacity: 0;
						transform: translate(100vw,0);
					}
				}
			}

			p {
				padding-bottom: .05rem;
				font-size: .32rem;
				font-weight: bold;
				color: transparent;
				background: linear-gradient(to bottom, #FFFFFF, #75DAFF);
				background-clip: text;
			}

			.welcome {
				position: absolute;
				top: .16rem;
				left: 1rem;
				font-size: .13rem;
				color: #79FFA7;
			}

			.date {
				position: absolute;
				top: .16rem;
				right: 1rem;
				font-size: .13rem;
				color: #79FFA7;
			}
		}

		.body {
			padding: 0 .25rem;

			&-col {
				z-index: 1;
				position: relative;
				width: 4.6rem;
				margin-bottom: .34rem;

				.module-box:nth-child(n+2) {
					margin-top: .24rem;
				}
			}
			
			&-main {
				position: relative;
			}
		}
		
		.foot {
			position: absolute;
			left: 50%;
			bottom: 0;
			height: 8px;
			transform: translate(-50%,0);
		}
	}
	
	.total {
		z-index: 1;
		position: relative;
		width: 100%;
		
		div {
			position: relative;
			padding: .2rem 0 1rem;
			
			&:before {
				content: '';
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
				background-image: url('~@/assets/image/digital/total_bg.png');
				background-size: 100% auto;
				background-repeat: no-repeat;
				background-position: center bottom;
				animation: totalBg 3s linear infinite;
			}
			
			strong {
				position: relative;
				font-size: .5rem;
				font-weight: normal;
				color: #00FF4E;
				animation: total 5s linear infinite;
			}
			
			p {
				position: relative;
				margin-top: .1rem;
				font-size: .18rem;
				color: #FFDC1A;
				animation: total 5s linear infinite;
			}
		}
	}

	@keyframes totalBg {
		0% {
			opacity: .4;
		}

		50% {
			opacity: 1;
		}

		100% {
			opacity: .4;
		}
	}
	
	@keyframes total {
		0% {
			transform: translate(0, -.06rem);
		}

		50% {
			transform: translate(0, .06rem);
		}

		100% {
			transform: translate(0, -.06rem);
		}
	}

	.map {
		position: absolute;
		left: 50%;
		bottom: 0;
		width: 16.75rem;
		height: 8.55rem;
		max-width: 1600px;
		max-height: 816px;
		margin-left: .5rem;
		transform: translate(-50%,0);
		
		.item {
			z-index: 1;
			position: absolute;
			transform: translate(-50%,-50%);
			cursor: pointer;
			
			.light {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				width: .1rem;
				height: .1rem;
				border-radius: 50%;
				animation: pointLight 3s linear infinite;
			}
			
			.point {
				position: relative;
				width: .1rem;
				height: .1rem;
				border-radius: 50%;
				background: #fff;
			}
			
			.content {
				position: absolute;
				left: 50%;
				bottom: -.08rem;
				transform: translate(-50%,0)
				opacity: 0;
				transition: opacity .5s linear;
				pointer-events: none;
				
				&.z-active {
					opacity: 1;
					transition: opacity 2s linear;
					
					&:before {
						width: 0;
						animation: pointLine .5s linear;
						animation-delay: 1s;
						animation-fill-mode: forwards;
					}
				
					.icon {
						animation: pointIcon 2s ease;
						animation-fill-mode: forwards;
					}
					
					.data {
						opacity: 0;
						animation: pointData .5s linear;
						animation-delay: 1.5s;
						animation-fill-mode: forwards;
					}
				}
				
				&:before {
					content: '';
					position: absolute;
					right: .2rem;
					bottom: .4rem;
					width: .75rem;
					height: .6rem;
					background-image: url('~@/assets/image/digital/map_line.png');
					background-position: right center;
					background-size: .75rem .6rem;
				}
				
				.icon {
					position: relative;
					width: .4rem;
					max-width: none;
					max-height: none;
				}
				
				.data {
					position: absolute;
					right: .95rem;
					bottom: .6rem;
					box-sizing: border-box;
					width: 1.8rem;
					height: .85rem;
					padding: 0 .2rem;
					line-height: .24rem;
					font-size: .13rem;
					color: #FFDC1A;
					background-image: url('~@/assets/image/digital/map_content.png');
					background-size: 100% 100%;
					opacity: 1;
				}
			}
		}
	}

	@keyframes pointLight {
		0% {
			opacity: 1;
			box-shadow: 0 0 0 0 rgba(255,220,26,.6);
		}

		100% {
			opacity: 0;
			box-shadow: 0 0 .2rem .3rem rgba(255,220,26,.6);
		}
	}

	@keyframes pointIcon {
		0% {
			transform: translate(0,-.2rem);
		}

		100% {
			transform: translate(0,0);
		}
	}

	@keyframes pointLine {
		0% {
			width: 0;
		}

		100% {
			width: .75rem;
		}
	}

	@keyframes pointData {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}
</style>
